import "./AboutSunil.module.css";
import Header from "@/reusable_sections/Header";
import Expertise from "./sections/Expertise";
import Milestones from "./sections/Milestones";
import Expertisefaq from "./sections/Expertisefaq";
import Footer from "@/reusable_sections/Footer";
export default function AboutSunilPage() {
  return <div>
      <Header />
      <Expertise />
      <Milestones />
      <Expertisefaq />
      <Footer />
    </div>;
}